export default __webpack_public_path__ + "static/media/iphone.713e1d4b.png";